import React from 'react';
import PastMembersPageComponent from '../components/PastMembersPage';


function PastMembersPage() {
  return (
    <PastMembersPageComponent/>
  );
}

export default PastMembersPage;
